import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import UploadPage from "../../components/UploadPage/UploadPage";
import "./UploadFilesPage.scss";

function UploadFilesPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const serviceConfig = location.state?.serviceConfig || null;

  // If no serviceConfig, redirect back to services
  useEffect(() => {
    if (auth.isAuthenticated && !serviceConfig) {
      navigate("/services", { replace: true });
    }
  }, [auth.isAuthenticated, serviceConfig, navigate]);

  const handleBack = () => navigate("/services");
  const handleStartSync = ({ jobId, videoKey, srtKey, videoFileName }) => {
    navigate("/sync", {
      state: { sessionId: { jobId, videoKey, srtKey }, videoFileName },
    });
  };

  const email = auth.user?.profile?.email || auth.user?.profile?.sub || "User";

  return (
    <div className="ufp-page">
      <main className="tab-panel">
        <UploadPage
          serviceConfig={serviceConfig}
          userEmail={email}
          onBack={handleBack}
          onStartSync={handleStartSync}
        />
      </main>
    </div>
  );
}

export default UploadFilesPage;
